import { useEffect } from 'react';
import { State, useStore } from 'store';

import fetchDashboardTaskCounts, { IDashboardTaskCountsParams } from 'store/fetchDashboardTaskCounts';

import IAsync from 'types/IAsync';
import IDashboardTaskCounts from 'types/IDashboardTaskCounts';

const POLL_INTERVAL_MS = 15000;

export default function useAutofetchedDashboardTaskCountsAsync(
  params: IDashboardTaskCountsParams = {},
): IAsync<IDashboardTaskCounts> {
  const taskCountsAsync = useStore((state: State) => state.dashboard.taskCountsAsync);

  const { userId, updatedWithinDays } = params;
  const projectIdsKey = (params.projectIds ?? []).join(',');

  useEffect(() => {
    const fetchParams: IDashboardTaskCountsParams = {
      projectIds: projectIdsKey ? projectIdsKey.split(',') : undefined,
      userId,
      updatedWithinDays,
    };
    fetchDashboardTaskCounts(fetchParams);
    const intervalId = setInterval(() => fetchDashboardTaskCounts(fetchParams), POLL_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [projectIdsKey, userId, updatedWithinDays]);

  return taskCountsAsync;
}
